import React from "react";

export const NotFoundContext = React.createContext();
